import { Button, TextInput } from 'carbon-components-react'
import { useEffect, useState } from 'react';
import styled from 'styled-components'
import Modal from '../../../components/Modal/Modal'

const addBtnStyle = {
  padding: "11px 18px",
    height: "auto",
    minHeight: "unset",
    borderRadius: "10px",
    fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif",
    fontWeight: 700,
    fontSize: "13.5px",
  width: "fit-content",
  marginLeft: "18px",
};

const TrialIdModal = ({
  open,
  onClose,
  onConfirm,
  data,
}) => {
  const [defaultId, setDefaultId] = useState(null)
  const [trialId, setTrialId] = useState(null)

  useEffect(() => {
    setDefaultId(data?.org_study_id)
  }, [])

  // when cancel reset to default ID88
  const handleClose = () => {
    onClose()
    setTrialId(defaultId)
  }

  const handleConfirm = () => {
    setDefaultId(trialId)
    onConfirm(trialId)
    onClose()
  }

  const onChangeId = (evt) => {
    setTrialId(evt.target.value)
  }

  return <Modal
    modalHeading="Update Sponsor Trial ID"
    size="sm"
    open={open}
    onRequestClose={handleClose}
  >
    <div style={{ marginBottom: "18px" }}>
      <p className="mb-4"><strong>Note:</strong>
        <UlStyled>
          <li>The <strong><em>Sponsor Trial ID</em></strong> is a case-sensitive field.</li>
          <li>To sync data from PRS please click the <strong><em>Regenerate CTG Data</em></strong> button.</li>
        </UlStyled>
      </p>
      <TextInput
        labelText="Sponsor Trial ID*"
        id="org_study_id"
        value={trialId}
        onChange={onChangeId}
        defaultValue={data?.org_study_id}
        required
      />
    </div>
    <ModalFooter>
      <Button
        kind="secondary"
        onClick={handleClose}
        style={addBtnStyle}
      >Cancel</Button>

      <Button
        kind="primary"
        type="submit"
        onClick={handleConfirm}
        style={addBtnStyle}
        disabled={!trialId}
      >Update Trial ID</Button>
    </ModalFooter>
  </Modal>
}

const ModalFooter = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`

const UlStyled = styled.ul`
  padding-left: 40px;
  list-style-type: disc;
`

export default TrialIdModal